import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './calcom-cancelled-badge.scss';

const buildCalcomBookingUrl = (bookingUid: string | null): string =>
  `https://cal.com/booking/${bookingUid}?changes=true`;

interface CalcomCancelledBadgeProps {
  calcomBookingUid: string | null;
}

const CalcomCancelledBadge = ({
  calcomBookingUid,
}: CalcomCancelledBadgeProps) => (
  <span className="calcom-cancelled">
    <span className="calcom-cancelled-badge">
      cancelled
      <a
        className="calcom-cancelled-badge-view"
        href={buildCalcomBookingUrl(calcomBookingUid)}
        target="_blank"
        rel="noopener noreferrer"
        title="View in Cal.com"
      >
        <FontAwesomeIcon glyph="calendar-times" weight="light" size="small" />
      </a>
    </span>
    <span className="calcom-cancelled-note">
      Cancelled on Cal.com — most likely by the event owner. If that&apos;s you,
      check your Cal.com account; otherwise contact the event owner shown on
      this event.
    </span>
  </span>
);

export default CalcomCancelledBadge;